/**
 * Operator-facing rep lock rules. Keep in sync with `src/sales-order/sales-order-rep-lock.ts`.
 */

import { isSalesOrderHubApprovedStatus } from "./salesOrderHubStatus.js";

export interface SalesOrderRepLockInput {
  status: string | null | undefined;
  repAgencyId: string | number | null | undefined;
  repSyncAt: string | null | undefined;
}

export function salesOrderRepFieldsLockedIn(order: SalesOrderRepLockInput): boolean {
  if (isSalesOrderHubApprovedStatus(order.status)) {
    return true;
  }
  const repSyncAt = order.repSyncAt;
  if (repSyncAt != null && String(repSyncAt).trim() !== "") {
    return true;
  }
  const repAgencyId = order.repAgencyId;
  return repAgencyId != null && String(repAgencyId).trim() !== "";
}
